import { CalendarCheck, ClipboardList, FilePenLine } from 'lucide-react';
import { capitalize, uniqBy } from 'lodash';
import { mapAppointment } from 'store/Appointments/helper';
import { PORTAL_ROUTES } from 'utils/constants';
import { formatDate, timeAgo } from 'utils/helpers';

export const BADGE = 'inline-flex shrink-0 items-center rounded-full border px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wider';
export const BADGE_COLORS = {
  blue: 'border-blue-100 bg-blue-50 text-blue-700',
  amber: 'border-amber-200 bg-amber-50 text-amber-700',
};

const listLabels = (labels = []) =>
  labels.length > 1 ? `${labels.slice(0, -1).join(', ')} and ${labels[labels.length - 1]}` : labels[0] || '';

// Keyed by the `type` of each `needs_attention` item from the dashboard API.
export const ATTENTION_ROWS = {
  unconfirmed_appointment: {
    icon: CalendarCheck,
    iconClass: 'bg-blue-100 text-blue-600',
    badgeColor: 'blue',
    title: () => 'Confirm your appointment',
    badge: ({ appointment }) => (appointment.appointmentAt ? timeAgo(appointment.appointmentAt) : ''),
    meta: ({ appointment }) =>
      [capitalize(appointment.type), `${formatDate(appointment.date, 'ddd, MMM D')} at ${appointment.startTime}`, appointment.provider.name]
        .filter(Boolean)
        .join(' · '),
    cta: 'Confirm',
  },
  treatment_consents: {
    icon: FilePenLine,
    iconClass: 'bg-amber-100 text-amber-600',
    title: ({ count }) => `Sign ${count} treatment consent${count === 1 ? '' : 's'}`,
    meta: ({ titles }) => listLabels(titles),
    cta: 'Review & sign',
    to: () => PORTAL_ROUTES.TREATMENT_CONSENTS,
  },
  patient_forms: {
    icon: ClipboardList,
    iconClass: 'bg-purple-100 text-purple-600',
    title: () => 'Finish your patient forms',
    meta: ({ completed, total, next }) => `${completed} of ${total} complete · Next up: ${next?.title}`,
    cta: 'Continue',
    to: ({ next }) => `${PORTAL_ROUTES.PROFILE}/${next?.id}`,
    progress: ({ completed, total }) => ({ value: completed, max: total }),
  },
};

// One row per type (so only the first unconfirmed appointment shows), with the appointment mapped for display.
export const getRows = (items: any[]) =>
  uniqBy(items.filter(({ type }) => ATTENTION_ROWS[type]), 'type').map((item) =>
    item.appointment ? { ...item, appointment: mapAppointment(item.appointment.attributes) } : item,
  );
